import React from 'react';
import { observer } from 'mobx-react';
import styled from '@emotion/styled';
import { Theme } from '@seedlang/constants';
import { ReviewHistoryWrapper } from '@seedlang/hoc';
import ReviewHistoryTable from 'components/review/review_history_table';

const Wrapper = styled.div`
  padding: 10px;
`;

const Table = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 10px;
  margin-bottom: 14px;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

const Cell = styled.div`
  text-align: left;
  flex: ${props => props.flex};
  padding: 4px 0;
  font-size: 13px;
  color: #333;
`;

const LabelCell = styled(Cell)`
  font-weight: bold;
  color: #777;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  flex: 1;
`;

const StatusTag = styled.div`
  background: ${props => props.background};
  color: #FFF;
  border-radius: 8px;
  font-size: 12px;
  padding: 3px 8px;
  font-weight: bold;
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

@observer
class ReviewHistory extends React.Component {
  render() {
    const card = this.props.card;

    return (
      <Wrapper>
        {
          card &&
          <Table>
            <Row>
              <LabelCell flex='1'>Reviews</LabelCell>
              <Cell flex='1'>{card.viewsCount ?? '-'}</Cell>
            </Row>
            <Row>
              <LabelCell flex='1'>Consecutive Positive</LabelCell>
              <Cell flex='1'>{card.consecutiveGoodScores ?? '-'}</Cell>
            </Row>
            <Row>
              <LabelCell flex='1'>Created</LabelCell>
              <Cell flex='1'>{card.createdAt?.fullTextFormattedDateWithYear || '-'}</Cell>
            </Row>
            <Row>
              <LabelCell flex='1'>Due</LabelCell>
              <Cell flex='1'>
                {this.props.reviewAfterText}
              </Cell>
            </Row>
            <Row>
              <LabelCell flex='1'>Status</LabelCell>
              <Cell flex='1'>
                {
                  card.retired &&
                  <StatusTag background={Theme.purple}>
                    <i className='fa fa-archive' style={{fontSize: '11px'}} />
                    Retired
                  </StatusTag>
                }
                {
                  !card.retired && this.props.isReviewPastDue &&
                  <StatusTag background={Theme.orange}>
                    <i className='fa fa-clock-o' style={{fontSize: '11px'}} />
                    Past Due
                  </StatusTag>
                }
                {
                  !card.retired && !this.props.isReviewPastDue &&
                  <StatusTag background={Theme.green}>
                    <i className='fa fa-check' style={{fontSize: '11px'}} />
                    Caught Up
                  </StatusTag>
                }
              </Cell>
            </Row>
          </Table>
        }
        <ReviewHistoryTable
          cardId={this.props.cardId}
          viewsCount={this.props.viewsCount}
          creationDateText={this.props.creationDateText}
        />
      </Wrapper>
    );
  }
}

export default ReviewHistoryWrapper(ReviewHistory);
